import { ActionElement } from '@aibees/elephant/feature/suggestion-search-bar/components/action-element';
import { Popover } from '@aibees/elephant/feature/suggestion-search-bar/components/popover';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { useRef } from 'react';
import { InputWrapper } from './components/input-wrapper';
import { RootContainer } from './components/root-container';
import { SuggestionSearchBarProvider } from './context/provider';
import { useDropDownConfig } from './hooks/use-drop-down-config';
import * as SX from './sx';
import {
  SuggestionSearchBarProps as Props,
  SuggestionSearchBarOptionBase,
} from './types';

export const SuggestionSearchBar = <T extends SuggestionSearchBarOptionBase>({
  className,
  placeholder: placeholderText,
  searchButton,
  onClickSearchButton,
  children,
  fetchOptions,
  defaultValue,
  onDelete,
  multiple,
  limit,
  limitErrorMsg,
  regex,
  errorMessage = 'Invalid input',
  searchCategory,
  searchIcon,
  renderMode,
  detailActionElement,
  deleteItemWithBackspace,
}: Props<T>) => {
  const childrenRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLDivElement>(null);

  const { width } = useDropDownConfig(
    { childrenRef, containerRef, inputRef },
    renderMode
  );

  return (
    <SuggestionSearchBarProvider
      baseState={{
        searchCategory,
        multiple,
        fetchOptions,
        errorMessage,
        regex,
        defaultValue,
        limit,
        placeholderText,
        onDelete,
        onClickSearchButton,
        limitErrorMsg,
        searchIcon,
        renderMode,
        detailActionElement,
        deleteItemWithBackspace,
      }}
    >
      <Box sx={SX.container} ref={containerRef}>
        <RootContainer className={classnames(className)}>
          <Box sx={SX.top} className={classnames('top')}>
            <Box sx={SX.scrollContent} ref={inputRef}>
              <InputWrapper />
            </Box>
            <Box
              sx={SX.actionBox(!!children || !!searchButton)}
              className={classnames('childrenContainer')}
            >
              {children && (
                <Box
                  sx={{ display: 'flex', alignItems: 'flex-start' }}
                  ref={childrenRef}
                >
                  {children}
                </Box>
              )}
              {searchButton && <ActionElement searchButton={searchButton} />}
            </Box>
          </Box>
          <Popover width={width} />
        </RootContainer>
      </Box>
    </SuggestionSearchBarProvider>
  );
};

SuggestionSearchBar.displayName = 'SuggestionSearchBar';
